import React from "react"
import {
  Container,
  Col,
  Row
} from 'reactstrap';

import ContentData from './data/ContentData.js'

function HomeScreen(){
    return(
        <div className="containhome">
          <Container fluid className="homepage fullscreen">
            <Row className="justify-content-center align-items-center">
              <Col lg="6" md="8" xs="12" className="text-right">
                <p>&nbsp;</p>
                <h1 className="display-1 home-1 text-center">
                {ContentData[0].data1}
                </h1>
                <h2 className="display-4 home-4 white text-center">
                {ContentData[1].data1}
                </h2>
              </Col>
            </Row>
          </Container>
          <Container fluid className="yourview fullscreen">
              <Row className="justify-content-center align-items-center">
              <Col lg="6" md="8" xs="12" className="text-right">
                  <p className="white text-right">
                  {ContentData[1].data3}
                  </p>
              </Col>
              </Row>
          </Container>
          </div>
    )
}
export default HomeScreen

